(() => {
  'use strict';

  if (customElements.get('cart-countdown-timer')) return;

  class CartCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.playInterval = null;
      this.isPlaying = false;
      this.initialDuration = 300;
    }

    connectedCallback() {
      this.initialDuration = parseInt(this.dataset.duration, 10) || 300;
      this.render();
      this.updateDisplay();
      this.playTimer();
    }

    disconnectedCallback() {
      this.pauseTimer();
    }

    render() {
      this.innerHTML = `
        <span class="cart-timer__label">Cart reserved for:</span>
        <span class="cart-timer__countdown">
          <span class="cart-timer__value" data-minutes></span>
          MIN :
          <span class="cart-timer__value" data-seconds></span>
          SEC
        </span>
      `;
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
    }

    formatNumber(value) {
      return value < 10 ? `0${value}` : `${value}`;
    }

    getRemainingSeconds() {
      const remaining = parseInt(this.dataset.duration, 10);
      return remaining > 0 ? remaining : 90;
    }

    updateDisplay() {
      const remaining = this.getRemainingSeconds();
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;

      if (this.minutesEl) {
        this.minutesEl.textContent = this.formatNumber(minutes);
      }

      if (this.secondsEl) {
        this.secondsEl.textContent = this.formatNumber(seconds);
      }
    }

    tick() {
      let remaining = parseInt(this.dataset.duration, 10);

      if (!remaining || remaining <= 0) {
        remaining = 90;
      } else {
        remaining -= 1;
      }

      this.dataset.duration = remaining;
      this.updateDisplay();
    }

    playTimer() {
      if (this.isPlaying) return;

      this.isPlaying = true;
      this.playInterval = setInterval(() => this.tick(), 1000);
    }

    pauseTimer() {
      if (this.playInterval) {
        clearInterval(this.playInterval);
        this.playInterval = null;
      }

      this.isPlaying = false;
    }
  }

  customElements.define('cart-countdown-timer', CartCountdownTimer);
})();
